export enum WithdrawalReason {
  Distance = 'distance',
  NoInterest = 'no_interest',
  OtherOffer = 'other_offer',
  Mistake = 'mistake',
}
